<script>
  import CategoriasVeicularesService from '../../../../domain/bem-categoria/services/categorias-veiculares'
  import LeilaoService from '../../../../domain/leiloes/services'
  import { isArray } from 'lodash'
  import SelectTipoBemOption from '../../../website/leiloes/components/SelectTipoBemRenderOption'

  export default {
    components: {SelectTipoBemOption},
    nome: 'nova-categoria-veicular',
    props: {
      viewerMode: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        data: {
          id: null,
          nome: null,
          metragemMedia: null,
          quantidadeFotos: 0,
          tipoBem: null
        },
        tiposBem: []
      }
    },
    computed: {
    },
    created () {
      this.isLoading = true
      LeilaoService.buscaTiposBem()
        .then((response) => {
          this.tiposBem = response.data.tipos
        })
        .catch((response) => {
          window.responseError(response)
          console.log(response)
        })
    },
    mounted () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      start () {
        if (this.$route.params.id && !this.viewerMode) {
          this.$loaderOverlay.open().message('Carregando')
          CategoriasVeicularesService.find(this.$route.params.id)
            .then((response) => {
              this.isLoaded = true
              this.$loaderOverlay.hide()
              this.data = response.data
              this.data.tipoBem = this.data.tipoBem ? this.data.tipoBem.id : null
              console.log(response)
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        } else {
          this.isLoaded = true
          // this.$loaderOverlay.open().message('Aguarde')
        }
      },
      submit () {
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$loaderOverlay.open().message('Processando...')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)
        CategoriasVeicularesService.cadastrar(this.data, this.$route.params.id).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionr para tela de visualização
              // this.$router.push({name: 'documento.editar', params: {id: response.data.id}})
              this.atualizadoSucesso = true
            }
            // TODO: TALVEZ CRIAR UM COMPONENTE REAPROVEITÁVEL DO FORM; implementação temporária por questão de tempo
            this.$emit('finishSubmit')
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      cancel () {
        if (this.viewerMode) {
          this.$emit('cancel')
        } else {
          this.$router.push({name: 'config.categorias.veiculares.list'})
        }
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Categoria Veicular</h1></div>
          <div class="col-sm-6">
            <router-link :to="{name: 'config.categorias.veiculares.list'}"
                         class="pull-right hidden-print" style="clear: left" v-if="!viewerMode">
              <strong class="label no-radius bg-info">Voltar</strong>
            </router-link>
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">

              <div class="form-group">
                <label class="col-sm-4 control-label">Nome</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.nome"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Metragem Média</label>
                <div class="col-sm-8">
                  <input type="number" step="0.1" class="form-control" v-model="data.metragemMedia"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Quantidade mínima de fotos</label>
                <div class="col-sm-8">
                  <input type="number" class="form-control" v-model="data.quantidadeFotos"/>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label" for="tiposBemSelect">Tipo de bem <i class="fa fa-question-circle" style="cursor: pointer" title="Tipo de bem que será relacionado ao criar lote"></i></label>
                <div class="col-sm-8">
                  <select id="tiposBemSelect" required v-model="data.tipoBem" class="form-control">
                    <option :value="null">Selecione</option>
                    <select-tipo-bem-option :tipo="tipoBem" v-for="tipoBem in tiposBem" :key="tipoBem.id">{{tipoBem.nome}}</select-tipo-bem-option>
                  </select>
                </div>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="cancel">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// NovaCategoria.vue?76704b7a